var _defs, _path, _rect, _polygon, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClyde(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 77.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #d1d1d1;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.77,15.29c5.29-.01,10.23,2.69,13.07,7.15l.1.15,6.35-3.08-.11-.19c-6.35-10.72-20.2-14.26-30.92-7.91-10.72,6.35-14.26,20.2-7.91,30.92,6.35,10.72,20.2,14.26,30.92,7.91,3.24-1.92,5.95-4.63,7.88-7.87l.12-.19-6.36-3.08-.1.15c-4.66,7.2-14.27,9.27-21.47,4.61-7.2-4.66-9.27-14.27-4.61-21.47,2.86-4.43,7.77-7.1,13.05-7.1h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 61.83,
    y: 9.17,
    width: 7.26,
    height: 42.95
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.78 43.05 80.95 22.86 72.88 22.86 85.75 52.27 77.02 72.21 85.1 72.21 106.69 22.86 98.61 22.86 89.78 43.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.72,9.17v14.86c-7.31-4.84-17.15-2.85-21.99,4.47-4.84,7.3-2.83,17.15,4.47,21.97,5.32,3.53,12.22,3.53,17.52,0v1.65h6.97V9.17h-6.97ZM122.97,46.61c-5.18,0-9.37-4.19-9.37-9.35s4.19-9.36,9.37-9.36,9.36,4.19,9.36,9.36-4.19,9.35-9.36,9.35Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 181.48,
    cy: 48.91,
    r: 4.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.48,37.3c.02-8.74-6.99-15.91-15.59-15.91-8.8-.17-16.07,6.82-16.25,15.62-.17,8.8,6.82,16.08,15.62,16.25.22.02.43.02.63,0,5.63,0,10.22-2.78,13.13-6.79l-5.81-2.91c-1.62,2.13-4.27,3.31-7.17,3.31-4.31.08-8.07-2.91-8.98-7.11h24.17c.19-.8.28-1.62.26-2.46ZM151.29,34c1.24-3.77,4.5-6.22,8.6-6.22s7.14,2.49,8.3,6.22h-16.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClyde);
export default __webpack_public_path__ + "static/media/clyde.8717191599c90ce0b74c974385dd9bc8.svg";
export { ForwardRef as ReactComponent };